(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-process-restart]');
    if (!button) return;
    const scope = button.closest('#erklaeranimation,.step-content');
    const video = scope?.querySelector('.process-animation__video');
    if (!video) return;
    let needsLoad = false;
    if (video.dataset.momSrc) {
      video.src = video.dataset.momSrc;
      delete video.dataset.momSrc;
      needsLoad = true;
    }
    video.querySelectorAll('source[data-mom-src]').forEach(source => {
      source.src = source.dataset.momSrc;
      delete source.dataset.momSrc;
      needsLoad = true;
    });
    if (needsLoad) video.load();
    video.currentTime = 0;
    video.play().catch(() => {});
  });
  const faq = document.querySelector('#fragen .faq-list');
  faq?.addEventListener('toggle', event => {
    const opened = event.target;
    if (!opened.matches('details') || !opened.open) return;
    faq.querySelectorAll('details[open]').forEach(item => {
      if (item !== opened) item.open = false;
    });
  }, true);
})();
